import { render, staticRenderFns } from "./DetalleVenta.vue?vue&type=template&id=24471604&"
import script from "./DetalleVenta.vue?vue&type=script&lang=ts&"
export * from "./DetalleVenta.vue?vue&type=script&lang=ts&"
import style0 from "./DetalleVenta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports